// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__9615L","range":"MonthRangeSwitch_range__O4wp7","disabled":"MonthRangeSwitch_disabled__3MAZU"};